import {
  baseUrl
} from '../config/env'
import store from '@/store/index'
import appBridge from '@/config/appBridge'
import Vue from 'vue'
import initAuth from '@/plugin/auth'
import { $timestampUTCStr, $isInIos } from '@/util/util'
export default (server = 'base', url = '', type = 'GET', data = {}, header = {
  jwtToken: false,
  accessToken: false,
  wsse: false
}, ok = 200, async = true, timeout = 0) => {
  let setHeader = function (requestObj) {
    requestObj.setRequestHeader('Content-Type', 'application/json;charset=utf-8')
    if (header.jwtToken) {
      // ios未登录的情况下 礼包列表的获取 是不能加Bearer的 不得已加到这里面
      let isLogin = !!store.state.userInfo.phoneNumber || !!store.state.userInfo.userName
      let jwtToken = !isLogin && $isInIos() ? 'WSSE profile="UsernameToken"' : `Bearer ${store.state.userInfo.jwtToken}`
      requestObj.setRequestHeader('Authorization', jwtToken)
    }
    header.accessToken && (requestObj.setRequestHeader('accessToken', store.state.userInfo.accessToken))
    if (header.wsse) {
      // requestObj.setRequestHeader('Authorization', 'WSSE profile="UsernameToken"')
      requestObj.setRequestHeader('X-WSSE', initAuth($timestampUTCStr(new Date())))
    }
  }
  return new Promise((resolve, reject) => { // 定义一个promise
    Vue.prototype.$showLoading.show()
    type = type.toUpperCase()
    url = baseUrl[server] + url
    let requestObj
    if (window.XMLHttpRequest) {
      requestObj = new XMLHttpRequest()
    } else {
      /* global ActiveXObject */
      requestObj = new ActiveXObject()
    }
    if (type === 'GET') {
      // let dataStr = '' // 数据拼接字符串
      // Object.keys(data).forEach(key => {
      //   dataStr += key + '=' + data[key] + '&'
      // })
      // dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'))
      // url = url + '?' + dataStr
      requestObj.open(type, url, async)
      setHeader(requestObj)
      requestObj.timeout = timeout
      requestObj.send()
    } else if (type === 'POST') {
      requestObj.open(type, url, async)
      requestObj.timeout = timeout
      setHeader(requestObj)
      if (data.type === 'code') {
        requestObj.send(data.data)
      } else {
        requestObj.send(JSON.stringify(data))
      }
    } else {
      reject(new Error('create request error!'))
    }
    requestObj.onreadystatechange = () => {
      if (requestObj.readyState === 4) {
        Vue.prototype.$showLoading.close()
        if (requestObj.status === ok) {
          try {
            let obj = requestObj.response
            if (obj && typeof obj !== 'object') {
              obj = JSON.parse(obj)
            }
            resolve(obj)
          } catch (e) {
            resolve(requestObj.response)
          }
        } else {
          if (requestObj.response) {
            reject(JSON.parse(requestObj.response))
          } else {
            reject(new Error('create request error!'))
          }
        }
      }
    }
    requestObj.ontimeout = () => {
      Vue.prototype.$toast('加载失败，请稍后重试', 1000)
      setTimeout(() => {
        appBridge.exitWebView(false)
      }, 600)
    }
  })
}
// export default axios
